import React, { useEffect } from "react";

const Modal = ({ children, onClose, contentClassName, backgroundClassName, beforeChildren, afterChildren, isSlider = false }) => {
  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => (document.body.style.overflowY = "scroll");
  }, []);

  return (
    <div className={`w-screen h-screen overflow-hidden fixed top-0 left-0 flex items-center justify-center z-[100] bg-black bg-opacity-40 ${backgroundClassName}`}>
      <div className="w-full h-full absolute top-0 left-0 cursor-pointer" onClick={onClose} />
      {beforeChildren}
      <div className={`max-w-4xl w-full ${isSlider ? "h-auto md:h-[600px]" : "h-[600px]"} relative z-[101] overflow-hidden rounded-lg mx-5 sm:mx-2 md:h-[90%] ${contentClassName}`}>
        {children}
      </div>
      {afterChildren}
    </div>
  );
};

export default Modal;
